import * as React from 'react';
import cx from 'classnames/bind';
import styles from './Spinner.scss';
import { mergeStyles } from '@uifabric/merge-styles';

const classNames = cx.bind(styles);

export enum SpinnerSize {
    /**
     * 12px Spinner diameter
     */
    xSmall = 0,

    /**
     * 16px Spinner diameter
     */
    small = 1,

    /**
     * 20px Spinner diameter
     */
    medium = 2,

    /**
     * 28px Spinner diameter
     */
    large = 3,
}

export interface SpinnerProps {
    /**
     * The size of Spinner to render. { extraSmall, small, medium, large }
     * @default SpinnerType.medium
     */
    size?: SpinnerSize;

    /**
     * Additional CSS class(es) to apply to the Spinner.
     */
    className?: string;

    /**
     * The color for the spinner
     */
    spinnerColor?: string;

    /**
     * The color for the handle which makes it appear like a broken rotating circle
     */
    handleColor?: string;

    /**
     * Aria label for the spinner
     */
    ariaLabel?: string;
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export class Spinner extends React.Component<SpinnerProps, any> {
    public static defaultProps: SpinnerProps = {
        size: SpinnerSize.medium,
    };

    public render() {
        const { size, className, spinnerColor, handleColor, ariaLabel } = this.props;

        const ariaProps = ariaLabel ? { 'aria-label': ariaLabel, tabIndex: 0 } : {};

        return (
            <div className={classNames('ms-Spinner', styles.root, className)} {...ariaProps}>
                <div
                    className={classNames(
                        'ms-Spinner-circle',
                        styles.circle,
                        {
                            ['ms-Spinner--xSmall ' + styles.circleIsXSmall]:
                                size === SpinnerSize.xSmall,
                            ['ms-Spinner--small ' + styles.circleIsSmall]:
                                size === SpinnerSize.small,
                            ['ms-Spinner--medium ' + styles.circleIsMedium]:
                                size === SpinnerSize.medium,
                            ['ms-Spinner--large ' + styles.circleIsLarge]:
                                size === SpinnerSize.large,
                        },
                        mergeStyles(
                            spinnerColor && { borderColor: `${spinnerColor} !important` },
                            handleColor && { borderTopColor: `${handleColor} !important` }
                        )
                    )}
                />
            </div>
        );
    }
}
